import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  PLATFORM_ID,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import Hls from 'hls.js';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ProductListComponent } from '../../components/product-list/product-list.component';
import { CanvasInfographicComponent } from '../../components/canvas-infographic/canvas-infographic.component';
import { SafeResourceUrlPipe } from '../../pipes/safe-resource-url.pipe';
import { RouterModule } from '@angular/router';

import 'swiper/element';
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    ProductListComponent,
    CanvasInfographicComponent,
    RouterModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponent implements AfterViewInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @ViewChildren('desktopVideo') desktopVideos!: QueryList<
    ElementRef<HTMLVideoElement>
  >;
  @ViewChildren('mobileVideo') mobileVideos!: QueryList<
    ElementRef<HTMLVideoElement>
  >;

  collection = 'taa-display';
  viewport_is_mobile = false;

  desktop_video_src =
    'https://cdn.assests.bornprimitive.com/taa-berry/video/desktop/playlist.m3u8';
  mobile_video_src =
    'https://cdn.assests.bornprimitive.com/taa-berry/video/mobile/playlist.m3u8';

  slides = [
    {
      title: 'BORN PRIMITIVE TACTICAL<br />FULL UNIFORM SET',
      contentDelay: 0,
      video: this.desktop_video_src,
      mobile_video: this.mobile_video_src,
      poster:
        'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/TAA-hero-banner-desktop.png?v=1746634252&width=2160',
      mobile_poster:
        'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Hero_BG_photo.png?v=1746634251&width=800',
      image: null,
      html: true,
    },
  ];

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.viewport_is_mobile = window.innerWidth < 768;
    }
  }

  onSlideChange(event: any) {
    console.log('Slide change:', event);
  }

  @ViewChildren('mainVideo') videoRefs!: QueryList<
    ElementRef<HTMLVideoElement>
  >;

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    // this.viewport_is_mobile = window.innerWidth < 768;

    const src = this.viewport_is_mobile
      ? this.mobile_video_src
      : this.desktop_video_src;

    this.videoRefs.forEach((videoEl) => {
      const video = videoEl.nativeElement;

      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.loop = true;

      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play().catch((err) => {
            console.warn('Autoplay error (HLS):', err);
          });
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
        video.addEventListener('loadedmetadata', () => {
          video.play().catch((err) => {
            console.warn('Autoplay error (native HLS):', err);
          });
        });
      }
    });

    setTimeout(() => {
      document.querySelectorAll('[data-delay]').forEach((node) => {
        const delay = (node as HTMLElement).getAttribute('data-delay');
        if (delay) {
          setTimeout(() => {
            node.classList.add('delay-complete');
          }, parseInt(delay, 10));
        }
      });
    }, 1);
  }
}
